// Slug -> gateway subPageType + literal searchParams for SDC Near Me Pages.
// SEO copy (title/description/H1/canonical) is supplied by the gateway, not here.
// Amenity slugs send the singular `amenity` CLP slug so the gateway's amenityMap
// (selfstorage_api_gateway SearchClient.js) interpolates it into the amenities
// filter — mirrors ssdr. Size slugs send a direct `sqft` range (no conversion).
export const nearMeKeywords = {
	// amenity slugs
	"24-hour-storage-units": {
		subPageType: "24-hour",
		searchParams: { amenity: "24-hour-access" }
	},
	"climate-controlled-storage-units": {
		subPageType: "climate-controlled",
		searchParams: { amenity: "climate-controlled" }
	},
	"drive-up-storage-units": {
		subPageType: "drive-up",
		searchParams: { amenity: "drive-up-self-storage" }
	},
	"storage-units-with-free-truck-rental": {
		subPageType: "free-truck-rental",
		searchParams: { amenity: "free-truck-rental" }
	},
	// size slugs
	"5x5-storage-units": {
		subPageType: "5x5",
		searchParams: { sqft: "0-25" }
	},
	"5x10-storage-units": {
		subPageType: "5x10",
		searchParams: { sqft: "26-60" }
	},
	"5x15-storage-units": {
		subPageType: "5x15",
		searchParams: { sqft: "61-75" }
	},
	"10x10-storage-units": {
		subPageType: "10x10",
		searchParams: { sqft: "76-100" }
	},
	"10x15-storage-units": {
		subPageType: "10x15",
		searchParams: { sqft: "101-150" }
	},
	"10x20-storage-units": {
		subPageType: "10x20",
		searchParams: { sqft: "151-200" }
	},
	"10x25-storage-units": {
		subPageType: "10x25",
		searchParams: { sqft: "201-250" }
	},
	"10x30-storage-units": {
		subPageType: "10x30",
		searchParams: { sqft: "251-300" }
	}
};

export function getKeywordConfig(slug) {
	return nearMeKeywords[slug] || null;
}
